export const infoagroPlans = {
  PLAN_COBRE: 'Plan Cobre',
  PLAN_PLATA: 'Plan Plata',
  PLAN_ORO: 'Plan Oro',
};
